module.exports = __webpack_public_path__ + "img/icon-mobile-apps.40f4eb5f.png";